import { EventSettingSimple, IEventSettingSimple } from "ui/Scripts/source/models/eventSettings/eventSettingSimple";
import { IEventDefaultHandler, EventDefaultHandler } from "./eventDefaultHandler";

export interface IGetEventDefaultHandlersResponse {
    items: IEventDefaultHandler[];
    unitId: string;
    unitCode: string;
    createCompanyUnitId: string;
    createCompanyUnitCode: string;
    canHandleEvent: boolean;
    canEditIdentificationData: boolean;
    eventSetting: IEventSettingSimple;
}

export class GetEventDefaultHandlersResponse implements IGetEventDefaultHandlersResponse {
    items: EventDefaultHandler[];
    unitId: string;
    unitCode: string;
    createCompanyUnitId: string;
    createCompanyUnitCode: string;
    canHandleEvent: boolean;
    canEditIdentificationData: boolean;
    eventSetting: EventSettingSimple;

    constructor();
    constructor(obj: IGetEventDefaultHandlersResponse);
    constructor(obj?: any) {
        this.unitId = obj && obj.unitId || "";
        this.unitCode = obj && obj.unitCode || "";
        this.createCompanyUnitId = obj && obj.createCompanyUnitId || "";
        this.createCompanyUnitCode = obj && obj.createCompanyUnitCode || "";
        this.canHandleEvent = obj && obj.canHandleEvent && obj.canHandleEvent === true;
        this.canEditIdentificationData = obj && obj.canEditIdentificationData && obj.canEditIdentificationData === true;
        this.items = [];
        if (obj && obj.items) {
            for (let i = 0; i < obj.items.length; i++) {
                this.items.push(new EventDefaultHandler(obj.items[i]));
            }
        }
        this.eventSetting = new EventSettingSimple(obj?.eventSetting);
    }
}